<div id="tour-agree-container" class="prospect-grid-container">
  <div id="tour-agree-top">
      <p *ngIf="model.TourType === 'selftour'" [innerHTML]=model.TourTextWarning></p>
      <p class="text-xs italic" *ngIf="model.TourType === 'selftour'" [innerHTML]=model.TourDisclaimer></p>
      <p>{{model.TourText}}</p>
      <p *ngIf="model.TourType === 'selftour'">{{model.TourText2}}</p>
      <div *ngIf="model.TourType === 'selftour'" class="flex justify-start my-5">
        <mat-checkbox class="mr-2" name="AgreeToWarning" id="AgreeToWarning" [(ngModel)]="agreeToWarning"
          #WarningAcknowledgement binary="true" required>
        </mat-checkbox>
        <div class="ml-2 text-gray-tricon">
          I understand and agree that this home is owned and managed by Tricon, and any lease signed outside of Tricon's online portal is fraudulent.
        </div>
      </div>
  </div>
  <div id="tour-agree-bottom" class="flex justify-end">
    <div class="w-full sm:w-1/4">
      <div class="grid col-gap-1">
        <button [disabled]="!agreeToWarning" mat-flat-button color="accent" (click)="onSubmit()">NEXT</button>
    </div>
  </div>
  </div>
</div>
